import React, { FC, useEffect, useState } from 'react';

import { FullScreenLoadingBox } from 'components';

import { ApiErrorPage } from '@britishcouncil/react-solas-ors3';

import { loadAppSettings } from './loadAppSettings';

import { AppSettingsContext, DEFAULT_APP_SETTINGS } from '.';

export const AppSettingsProvider: FC = ({ children }) => {
  const [appSettingsState, setAppSettings] = useState(DEFAULT_APP_SETTINGS);

  useEffect(() => {
    loadAppSettings()
      .then((val) => {
        setAppSettings({
          ...(val.userManager.authority?.indexOf('#') !== 0 ? val : DEFAULT_APP_SETTINGS),
          status: 'loaded',
        });
      })
      .catch((e) => {
        setAppSettings({
          ...DEFAULT_APP_SETTINGS,
          status: 'error',
        });
      });
  }, []);

  return (
    <AppSettingsContext.Provider value={appSettingsState}>
      {appSettingsState.status === 'loading' && <FullScreenLoadingBox />}
      {appSettingsState.status === 'error' && (
        <ApiErrorPage errorMessage="Page could not be loaded. Please try again later." />
      )}
      {appSettingsState.status === 'loaded' && children}
    </AppSettingsContext.Provider>
  );
};
